import { route } from '../helpers';

import { PromotionPages } from '../../constants/AppConstants';

module.exports = route(PromotionPages.APPLY_PROMOTION, {
    getComponent(location, cb) {
        require.ensure([], (require) => {
            cb(null, require('../../components/promotion/ApplyPromotion').default);
        }, 'promotion-apply');
    }
});



// WEBPACK FOOTER //
// ./src/routes/Promotion/Apply.js